var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.646 2.396 15.62 8.29l5.724.567a.715.715 0 0 1 .444 1.221l-4.71 4.67 1.746 6.345a.723.723 0 0 1-1.023.831l-5.803-2.874-5.795 2.87a.723.723 0 0 1-1.023-.83l1.746-6.346-4.714-4.67a.716.716 0 0 1 .444-1.22l5.724-.568 2.97-5.889a.728.728 0 0 1 1.296 0",
    clipRule: "evenodd"
  })));
};
export default SvgStarFilled;